export const menuPanelDict = {
  en: {
    aboutTitle: 'About Us',
    featuredTitle: 'Featured',
  },
  de: {
    aboutTitle: 'Über uns',
    featuredTitle: 'Ausgewählte',
  },
  ru: {
    aboutTitle: 'Компания',
    featuredTitle: 'Избранные статьи',
  },
  tr: {
    aboutTitle: 'Hakkımızda',
    featuredTitle: 'Öne Çıkanlar',
  },
  es: {
    aboutTitle: 'Sobre nosotros',
    featuredTitle: 'Destacados',
  },
};
